export const NON_NUMERIC_REGEX = /\D/g;
export const DIGITS_ONLY_REGEX = /^[0-9]+$/;
export const EMAIL_VALIDATION_REGEX = /^[a-z0-9.]+@stengg\.com$/;
export const EMAIL_VALID_CHARACTERS_REGEX = /[^a-z0-9.@]/g;
export const PASSWORD_VALIDATION_REGEX =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[ !@#$%^&*()_+\-=])[A-Za-z\d !@#$%^&*()_+\-=]{12,}$/;
export const PASSWORD_MIN_LENGTH_REGEX = /^.{12,}$/;
export const PASSWORD_UPPERCASE_REGEX = /[A-Z]/;
export const PASSWORD_LOWERCASE_REGEX = /[a-z]/;
export const PASSWORD_NUMBER_REGEX = /\d/;
export const PASSWORD_SPECIAL_CHAR_REGEX = /[ !@#$%^&*()_+\-=]/;
export const DIGITS_AND_CHARS_ONLY_REGEX = /^[a-zA-Z0-9]+$/;
